import { useState } from 'react'
import { useDispatch } from 'react-redux'
import {
  Box,
  Skeleton,
  Text
} from '@chakra-ui/react'
import {
  AnimatePresence,
  motion
} from 'framer-motion'
import { savePost } from 'store'
import { COLORS } from 'utils/styles'
import { ImagesPng } from 'assets/images'
import { CloseIcon } from 'assets/icons'
import { useGoToProfileMarker } from 'hooks/useGoToProfileMarker'
import {
  StyledImage,
  StyledBlogImage
} from './styled'

const MotionBox = motion(Box)

export const SavedBlogs = ({
  engagementItems,
  engagementTimeFormat,
  items,
  openPost,
  secondToLastItem
}) => {
  const dispatch = useDispatch()
  const [loadedProfileImage, setLoadedProfileImage] = useState({})
  const [loadedPostImage, setLoadedPostImage] = useState({})
  const itemCountPerBatch = Math.ceil(window.innerHeight / 80)
  const goToProfileMarker = useGoToProfileMarker()

  const handleProfileImage = (postId) => {
    setTimeout(() => {
      setLoadedProfileImage((prev) => ({
        ...prev,
        [postId]: true
      }))
    }, 500)
  }

  const handlePostImage = (postId) => {
    setTimeout(() => {
      setLoadedPostImage((prev) => ({
        ...prev,
        [postId]: true
      }))
    }, 500)
  }

  const displayImage = (item) => {
    if (item?.imageLoaded || item?.imageLoaded === undefined) {
      return item?.post_image ?? ImagesPng.PlaceholderRectangle
    }

    return ImagesPng.PlaceholderRectangle
  }

  return (
    <AnimatePresence initial={false} mode="sync">
      {
        items.map((item) => (
          <MotionBox
            ref={item.index === engagementItems.length - 2 ? secondToLastItem : null}
            key={item.post_id}
            initial={{ height: 0 }}
            animate={{ height: 'auto' }}
            exit={{ height: 0 }}
            transition={{
              ease: [0, 0.2, 0.6, 1],
              duration: 0.8
            }}
            transformOrigin="top"
            overflow="hidden"
            position="relative"
          >
            <Box
              display="flex"
              justifyContent="space-between"
              backgroundColor={COLORS.white}
              border="solid black 1px"
              borderBottomRadius={
                item.index === engagementItems.length - 1
                && engagementItems.length - 1 >= itemCountPerBatch
                  ? '10px'
                  : ''
              }
              cursor="pointer"
            >
              <Box
                onClick={(e) => {
                  e.stopPropagation()

                  goToProfileMarker({
                    profileId: item.profile_id,
                    coordinates: item.coordinates
                  })
                }}
              >
                <Skeleton
                  isLoaded={loadedProfileImage[item.post_id]}
                  fadeDuration={1}
                  width="110px"
                  height="130px"
                  margin="5px"
                  borderRadius="5px"
                >
                  <StyledImage
                    src={item?.profile_picture ?? ImagesPng.ProfileImage}
                    onLoad={() => handleProfileImage(item.post_id)}
                  />
                </Skeleton>
              </Box>

              <Box
                as="button"
                flex="1"
                display="flex"
                flexFlow="column"
                overflow="hidden"
                width="100%"
                maxHeight="140px"
                padding="0 5px 5px 0"
                minWidth="0px"
                cursor="pointer"
                onClick={() => openPost(item, 'middle')}
              >
                <Box
                  width="100%"
                  textAlign="center"
                  background={COLORS.lightGoldGradientLeftToRight}
                  borderRadius="5px"
                  marginTop="5px"
                  fontSize="16px"
                  padding="0 10%"
                  position="relative"
                >
                  <Text
                    textOverflow="ellipsis"
                    overflow="hidden"
                    whiteSpace="nowrap"
                  >
                    {item.post_title}
                  </Text>

                  <Box
                    position="absolute"
                    top="0.5"
                    right="5px"
                    onClick={(e) => {
                      e.stopPropagation()
                      dispatch(savePost(item.post_id))
                    }}
                  >
                    <CloseIcon
                      width="19px"
                      height="20px"
                    />
                  </Box>
                </Box>

                <Box
                  marginTop="5px"
                  position="relative"
                  overflow="hidden"
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  borderRadius="5px"
                  border="solid 0.5px black"
                >
                  <Skeleton
                    isLoaded={
                      (
                        loadedPostImage[item.post_id] && item?.imageLoaded === undefined
                      ) || item?.imageLoaded
                    }
                    fadeDuration={1}
                    width="100%"
                    height="140px"
                    alignContent="center"
                    display="grid"
                  >
                    <StyledBlogImage
                      src={displayImage(item)}
                      onLoad={() => handlePostImage(item.post_id)}
                    />

                    <Box
                      bgGradient="linear(135deg, rgba(255,255,255,0.25), rgba(255,255,255,0.05))"
                      backdropFilter="blur(3px) saturate(150%)"
                      border="1px solid rgba(255, 255, 255, 0.3)"
                      borderRadius="5px"
                      boxShadow="
                        inset 0 0 20px rgba(255,255,255,0.1),
                        0 4px 22px rgba(31, 38, 135, 0.37)
                      "
                      padding="2.5px 10px"
                      position="absolute"
                      top="0"
                      left="0"
                      pointerEvents="none"
                    >
                      <Text fontSize="16px">
                        {engagementTimeFormat(item?.created_at)}
                      </Text>
                    </Box>
                  </Skeleton>
                </Box>
              </Box>
            </Box>
          </MotionBox>
        ))
      }
    </AnimatePresence>
  )
}
